export default function() {}



// WEBPACK FOOTER //
// ./resources/assets/js/auth/lib/mixins/created.js